import React from 'react';
import { IAdminView, adminShareView } from '../../api/admin';
import ShareResourceDialog from './ShareResourceDialog';

interface Props {
	open: boolean;
	onClose: () => void;
	views: IAdminView[];
	sourceUserId: number;
}

export default function ShareViewsDialog({ open, onClose, views, sourceUserId }: Props) {
	async function handleShare(
		itemIds: number[],
		targetUserIds: number[],
		newNames: Record<number, string>,
		overwrite: boolean,
		skipChecks: boolean,
	) {
		await Promise.all(
			itemIds.flatMap((id) => targetUserIds.map((uid) => adminShareView(id, uid, newNames[id], overwrite, skipChecks)))
		);
	}

	return (
		<ShareResourceDialog
			open={open}
			onClose={onClose}
			items={views}
			allowSkipChecks
			resourceLabel="view"
			sourceUserId={sourceUserId}
			onShare={handleShare}
		/>
	);
}
